export function SET_JOB(state, job) {
  state.job = job;
}

export function SET_NOTE(state, nota){
  if(!state.job.notas) state.job.notas = []
  nota.criado_em = new Date()
  state.job.notas.push(nota)

}

export function SET_ATTACH(state, attach){
  if(!state.job.arquivos) state.job.arquivos = []
  state.job.arquivos.push(attach)
}